import * as $ from 'jquery';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import Fuse from 'fuse.js';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { ExcelService } from '../../../services/infrastructure/excel.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CommonService } from '../../../services/common/common.service';
import { OTIOrderLandingFilterVM } from '../../../models/OTI/OTIOrderLandingFilterVM';
import { OtiService } from '../../../services/oti/oti.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { OtiOrderDetailSliderModelService } from '../oti-order-detail/oti-order-detail-slider-model.service';
import { MatDateRangeInput } from '@angular/material/datepicker';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { OtiAdvancedSearchComponent } from '../oti-advanced-search/oti-advanced-search.component';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: "app-oti-order-landing",
  templateUrl: "./oti-order-landing.component.html",
  styleUrls: ["./oti-order-landing.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class OtiOrderLandingComponent implements OnInit, OnDestroy, DoCheck {
  @ViewChild("otiOrdersTable", { read: MatSort }) otiOrdersSort: MatSort;
  @ViewChild("otiOrdersPaginator", { read: MatPaginator })
  otiOrdersPaginator: MatPaginator;
  @ViewChild("oipOrdersPaginator", { read: MatPaginator })
  oipOrdersPaginator: MatPaginator;

  @ViewChild("menuTrigger") menu: MatMenuTrigger;
  @ViewChild("menuStatusTrigger") menuStatus: MatMenuTrigger;

  @ViewChild("dateRangeInput") dateRangeInput: MatDateRangeInput<Date>;
  initialStartDate: Date | null = null;
  initialEndDate: Date | null = null;
  private subscription = new Array<Subscription>();
  public otiOrdersDataSource: MatTableDataSource<any>;
  isSingleParent = false;

  headerCompany = MasterConstants.US_COMPANYCODE;
  validateEvolveData: any;
  userMenuAccessList: any;
  expandedElement: any | null;
  otiOrdersList: any = [];
  selectedYearType: string = '';
  tabNode: string = '';
  selectedYearTypeId: string = 'CALY';
  selectedYearTypeDefault: string = '';
  selectedYearTypeDefaultValues: string = '';
  selectedCurrentYear: string = '';
  selectedPreviousYear: string = '';
  selectedPreviousYear2: string = '';
  shiptoDefaultList: string = null;
  orderStatusList: any = [];
  productSearchListDataCPP: Array<any> = [];
  productSearchListDataSEED: Array<any> = [];
  vendorSearchListData: Array<any> = [];
  currentSearchCriteriaCpp: any;
  currentSearchCriteriaSeed: any;
  searchOrderFromDate: any;
  searchOrderToDate: any;
  showHideDateFilter: boolean = true;
  filtersSummaryMasterData: { [key: string]: DropdownItem[] } = {
    brandsList: [],
    parentAccountsList: [],
    locationsList: [],
    activeIngredientsList: [],
    yearTypesList: []
  };
  fullRawListData: any[] = [];

  filtersSummary: any = {
    parentAccounts: null,
    locations: null,
    activeIngredients: null,
    brands: null,
    yearTypes: 'CALY'
  };
  orderColumns: string[] = [
    "webOrderNumber",
    "orderNumber",
    "customerPO",
    "orderDate",
    "orderType",
    "productName",
    "vendor",
    "shipToLocation",
    "orderedQty",
    "deliveredQty",
    "UOM",
    "orderStatus",
    "trackingURL",
    "addIcon",
  ];

  childColumns: string[] = [
    "webOrderNumber",
    "orderNumber",
    "customerPO",
    "orderDate",
    "orderTypeText",
    "productName",
    "vendor",
    "shipToLocation",
    "orderedQty",
    "deliveredQty",
    "UOM",
    "orderStatus",
    "trackingURL",
    "addIcon",
  ];

  seedOrderColumns: string[] = [
    "orderNumber",
    "customerPO",
    "orderDate",
    "orderType",
    "itemDescription",
    "marketingBrand",
    "shipToLocation",
    "lotNumber",
    "orderedQty",
    "deliveredQty",
    "orderStatus",
    "trackingURL",
    "addIcon",
  ];

  seedChildColumns: string[] = [
    "orderNumber",
    "customerPO",
    "orderDate",
    "orderTypeText",
    "itemDescription",
    "marketingBrand",
    "shipToLocation",
    "lotNumber",
    "orderedQty",
    "deliveredQty",
    "orderStatus",
    "trackingURL",
    "addIcon",
  ];

  groupHeaderRow = ['emptyColumn', 'selectedCurrentYear', 'selectedPreviousYear', 'selectedPreviousYear2'];

  orderInsightsColumns: string[] = [
    "product",
    "packageSize",
    "dateRange",
    //"uom",
    "currentYearOrderedQTY",
    "currentYearInvoicedOrShippedQTY",
    "previousYearOrderedQTY",
    "previousYear2OrderedQTY",
    //"addToCart",
  ];

  orderInsightsChildColumns: string[] = [
    "product",
    "packageSize",
    "dateRange",
    //"uom",
    "currentYearOrderedQTY",
    "currentYearInvoicedOrShippedQTY",
    "previousYearOrderedQTY",
    "previousYear2OrderedQTY",
    //"addToCart"
  ];

  orderInsightsMonthChildColumns: string[] = [
    "product",
    "packageSize",
    "monthName",
    //"uom",
    "currentYearOrderedQTY",
    "currentYearInvoicedOrShippedQTY",
    "previousYearOrderedQTY",
    "previousYear2OrderedQTY",
  ];

  orderInsightsPackageDateRangeColumns: string[] = [
    "product",
    "packageSize",
    "monthName",
    //"uom",
    "currentYearOrderedQTY",
    "currentYearInvoicedOrShippedQTY",
    "previousYearOrderedQTY",
    "previousYear2OrderedQTY",
  ];

  packageDateRangeDataSource = new MatTableDataSource<any>([]);
  isParentRow = (index: number, row: any) => row.isParent;
  isChildRow = (index: number, row: any) => !row.isParent;

  public orderInsightDataSource: MatTableDataSource<any>;

  expandedType: 'packageSize' | 'dateRange' | 'multiLevel' | null = null;

  toggleOrderInsightRow(element: any, type: 'packageSize' | 'dateRange') {
    if (this.expandedElement === element && (this.expandedType === type || this.expandedType === 'multiLevel')) {
      this.expandedElement = null;
      this.expandedType = null;
    }
    else if (this.expandedElement === element && this.expandedType !== type) {
      this.setTableData(element);
      this.expandedElement = element;
      this.expandedType = 'multiLevel';
    }
    else {
      this.expandedElement = element;
      this.expandedType = type;
    }

  }

  filter: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  cppFilters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  seedFilters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  baseFilters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  selectedTabIndex = 0;
  activeOrderTab: number = 0;
  isPickerOpen: boolean = false;
  isSeedOrderAccess = false;
  isCPPOrderAccess = false;
  isOiAccess = false;
  maxOrderDate = new Date();
  minOrderDate = new Date();
  currentTab = 0;
  searchPlaceHolder = "Single or Multiple keyword search. Click on (?) for examples";
  selectedTab: string = "CPP";
  isCPPAdvancedSearch: boolean = false;
  isSEEDAdvancedSearch: boolean = false;
  shippedInTransitMessage: string = '';
  shouldShowSurveyMessage: boolean = false;
  evolveSurveyUrl: string = '';
  private surveyTimeoutId: any;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private excelService: ExcelService,
    private otiService: OtiService,
    private commonService: CommonService,
    private otiOrderDetailSliderModelService: OtiOrderDetailSliderModelService
  ) { }

  // page initilization code
  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(
        this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)
      );
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        let headerCompanyCode = this.localStorageService.get(
          MasterConstants.HEADER_COMPANY_CODE
        );
        let userAccessByCompany = data.resultData.find(
          (x) =>
            headerCompanyCode &&
            x.userIdCompanyCode == JSON.parse(headerCompanyCode)
        );
        const userMenuAccessList =
          userAccessByCompany == null
            ? []
            : userAccessByCompany.userMenuAccessList;

        this.isSeedOrderAccess =
          this.commonService.checkUserRoleAccessTypeForMenu(
            userMenuAccessList,
            MasterConstants.FUNCTION_CODE.DEALER_ORDERS_TAB
          );
        this.isCPPOrderAccess =
          this.commonService.checkUserRoleAccessTypeForMenu(
            userMenuAccessList,
            MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER
          );
        this.isOiAccess = this.commonService.checkUserRoleAccessTypeForMenu(userMenuAccessList, MasterConstants.FUNCTION_CODE.ORDER_INSIGHTS);
        if (this.isSeedOrderAccess || this.isCPPOrderAccess) {
          // set min date for 19 months
          this.minOrderDate.setDate(this.maxOrderDate.getDate() - 580);
          this.setDefaultDateFilter();
        } else {
          this.router.navigate(["/cc/landing-data"]);
        }
      }
    }

    if (this.localStorageService.get(MasterConstants.CPP_PRODNAME_SEARCH_OPTIONS)) {
      this.productSearchListDataCPP = JSON.parse(this.localStorageService.get(MasterConstants.CPP_PRODNAME_SEARCH_OPTIONS));
      this.productSearchListDataCPP = this.productSearchListDataCPP.map(a => a.id);
    }
    this.subscription.push(this.otiService.getSeedSearchList().subscribe((result: any) => {
        this.productSearchListDataSEED = result;
        this.productSearchListDataSEED = this.productSearchListDataSEED.map(a => a.id);
    }));

    if (this.localStorageService.get(MasterConstants.VENDORNAME_SEARCH_OPTIONS)) {
      this.vendorSearchListData = JSON.parse(this.localStorageService.get(MasterConstants.VENDORNAME_SEARCH_OPTIONS));
      this.vendorSearchListData = this.vendorSearchListData.map(a => a.id);
    }

  }

  checkSurveyMessageEligibilty() {
    this.subscription.push(this.otiService.checkSurveyMessageEligibilty().subscribe((result: any) => {
      this.shouldShowSurveyMessage = result.shouldShowSurveyMessage;
      this.evolveSurveyUrl = result.surveyUrl;
      if (this.shouldShowSurveyMessage) {
        this.surveyTimeoutId = setTimeout(() => {
          this.showSurveyMessage();
        }, 5000);
      }
    }));
  }

  ngDoCheck() {
    var widthButtonElem = document.querySelector<HTMLElement>(".selectStatus");
    if (widthButtonElem) {
      var widthButton = widthButtonElem.offsetWidth;
      var elems = Array.from(
        document.getElementsByClassName(
          "mat-menu-panel"
        ) as HTMLCollectionOf<HTMLElement>
      );
      for (var i = 0; i < elems.length; i++) {
        elems[i].style.width = widthButton + "px";
      }
    }

    var widthButtonDateElem =
      document.querySelector<HTMLElement>(".selectDateRange");
    if (widthButtonDateElem) {
      var widthButtonDate = widthButtonDateElem.offsetWidth;
      var elems = Array.from(
        document.getElementsByClassName(
          "dropdown-content-new"
        ) as HTMLCollectionOf<HTMLElement>
      );
      for (var i = 0; i < elems.length; i++) {
        elems[i].style.width = widthButtonDate + 40 + "px";
      }
    }
  }

  @HostListener("window:resize", ["$event"]) onresize(event) {
    this.setHeight();
    this.setSeedOrdersTableHeight();
  }

  ngAfterViewInit() {
    this.setHeight();
    this.setSeedOrdersTableHeight();
  }

  handleOrderTabChange(event: MatTabChangeEvent) {
    this.selectedTab = "CPP";
    if (this.selectedTabIndex === 1 && this.isSeedOrderAccess) {
      this.seedFilters.searchText = this.filter.searchText;
    } else {
      this.cppFilters.searchText = this.filter.searchText;
    }
    this.activeOrderTab = event.index;
    if (this.activeOrderTab === 1) {
      this.getFilterMasterDataOIP();
    } else {
      this.SetOipDataSource([]);
      this.expandedElement = null;
      this.expandedType = null;
      this.filter.searchText = this.cppFilters ? this.cppFilters.searchText : '';
      this.selectedTabIndex = 0;
    }
    setTimeout(() => {
      this.setHeight();
      this.setSeedOrdersTableHeight();
    }, 0);
  }

  SetOipDataSource(result: any) {
    this.orderInsightDataSource = new MatTableDataSource(result);
    this.orderInsightDataSource.paginator = this.oipOrdersPaginator;
    this.orderInsightDataSource.paginator.firstPage();
  }

  getSelectedYearTypeLabel(): string {
    return this.filtersSummaryMasterData.yearTypesList?.length > 0 ? `${this.selectedYearType}` : 'Year Type';
  }

  selectYearType(e: any): void {
    this.selectedYearType = e.value;
    this.selectedYearTypeId = e.id;
  }

  updateFiltersSummary(): void {
    const keys = [
      { field: 'parentAccounts', source: 'parentAccountsList' },
      { field: 'locations', source: 'locationsList' },
      { field: 'activeIngredients', source: 'activeIngredientsList' },
      { field: 'brands', source: 'brandsList' }
    ];

    keys.forEach(({ field, source }) => {
      const selectedItems = this.filtersSummaryMasterData[source]?.filter(
        (item: any) => item.selected && item.id !== 'ALL'
      );
      if (field === "activeIngredients") {
        this.filtersSummary[field] = selectedItems?.map((item: any) => item.id).join(';') || null;
      } else {
        this.filtersSummary[field] = selectedItems?.map((item: any) => item.id).join(',') || null;
      }
    });

    this.filtersSummary.yearTypes = this.selectedYearTypeId || null;
  }

  clearAllFilters(): void {
    if (this.isSingleParent) {
      this.updateDropdownList('parentAccountsList', this.fullRawListData, 'soldToAccountNumber', 'soldToAccountName', true);

    } else {
      this.updateDropdownList('parentAccountsList', this.fullRawListData, 'soldToAccountNumber', 'soldToAccountName', true);
    }
    this.updateDropdownList('locationsList', this.fullRawListData, 'accountNumber', 'accountName', true);
    this.updateDropdownList('brandsList', this.fullRawListData, 'marketingBrandId', 'marketingBrand', true);
    this.updateDropdownList('activeIngredientsList', this.fullRawListData, 'activeIngredients', 'activeIngredients', true);
    this.selectedYearType = this.selectedYearTypeDefault;
    if (this.shiptoDefaultList) {
      this.assignYearsHeaders(this.selectedYearTypeDefaultValues);
    }
    this.selectedYearTypeId = 'CALY';
    this.filtersSummary = {
      parentAccounts: null,
      locations: null,
      activeIngredients: null,
      brands: null,
      yearTypes: 'CALY'
    };
    this.expandedElement = null;
    this.expandedType = null;
    this.oipOrdersPaginator.pageSize = 20;   // Set default size
    this.oipOrdersPaginator.firstPage();     // Go to first page (pageIndex = 0)
    if (this.isSingleParent) {
      this.getOipOrders();
    } else {
      this.SetOipDataSource([]);
    }

  }


  getFilterMasterDataOIP() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.otiService.getFilterMasterDataOIP().subscribe((result: any) => {
      if (result && result.masterDataList.length > 0) {
        this.fullRawListData = result.masterDataList;
        this.updateDropdownList('parentAccountsList', result.masterDataList, 'soldToAccountNumber', 'soldToAccountName', true);
        this.updateDropdownList('locationsList', result.masterDataList, 'accountNumber', 'accountName', true);
        this.updateDropdownList('brandsList', result.masterDataList, 'marketingBrandId', 'marketingBrand', true);
        this.updateDropdownList('activeIngredientsList', result.masterDataList, 'activeIngredients', 'activeIngredients', true);
        this.filtersSummaryMasterData.yearTypesList = result.yearTypes;
        var selectedYearType = result.yearTypes.find(x => x.id === this.selectedYearTypeId);
        if (!selectedYearType) {
          if (result.yearTypes && result.yearTypes.length > 0) {
            selectedYearType = result.yearTypes[0];
            this.selectedYearTypeId = selectedYearType.id;
          }
        }

        this.selectedYearTypeDefault = selectedYearType?.value || '';
        this.selectedYearTypeDefaultValues = selectedYearType?.data || '';
        this.shiptoDefaultList = this.getDistinctAccountNumbers(result.masterDataList, 'accountNumber');
        this.assignYearsHeaders(this.selectedYearTypeDefaultValues);
        this.selectedYearType = this.selectedYearTypeDefault;
        if (this.hasAtLeastTwoParents(result.masterDataList)) {
          this.filtersSummaryMasterData.parentAccountsList.forEach(x => x.selected = true);
          this.isSingleParent = true;
          if (!selectedYearType) {
            this.toastrService.error('Year type is not selected');
            this.loaderService.setLoaderStatus(false);
          }
          else {
            this.getOipOrders();
          }
        }
        else {
          this.loaderService.setLoaderStatus(false);
        }

      } else {
        this.filtersSummaryMasterData.yearTypesList = result.yearTypes;
        const selectedYearType = result.yearTypes.find(x => x.id === this.selectedYearTypeId);
        this.selectedYearTypeDefault = selectedYearType?.value || '';
        this.selectedYearTypeDefaultValues = selectedYearType?.data || '';
        this.selectedYearType = this.selectedYearTypeDefault;
        this.loaderService.setLoaderStatus(false);
      }
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  getDistinctAccountNumbers(list: any[], key: string): string | null {
    if (!Array.isArray(list) || list.length === 0) return null;

    const seen: Record<string, boolean> = {};
    const distinct: string[] = [];

    for (const item of list) {
      const value = item?.[key];
      if (value && !seen[value]) {
        seen[value] = true;
        distinct.push(value);
      }
    }

    return distinct.length > 0 ? distinct.join(',') : null;
  }


  hasAtLeastTwoParents(data: any[]): boolean {
    const seen = new Set<string>();
    for (const item of data) {
      if (item?.soldToAccountNumber != null) {
        seen.add(item.soldToAccountNumber);
        if (seen.size >= 2) {
          return false;
        }
      }
    }
    return true;
  }

  loadOIPData() {
    var selectedYearType = this.filtersSummaryMasterData.yearTypesList.filter(x => x.id == this.selectedYearTypeId)[0];
    if (selectedYearType) {
      if (this.shiptoDefaultList) {
        this.assignYearsHeaders(selectedYearType.data);
      }
      this.getOipOrders();
    }
    else {
      this.toastrService.error('Please select year type');
    }
  }

  getOipOrders() {
    this.expandedElement = null;
    this.expandedType = null;
    this.updateFiltersSummary();
    const filter = {
      soldToAccounts: this.filtersSummary.parentAccounts,
      shipToAccounts: this.filtersSummary.locations ? this.filtersSummary.locations : this.shiptoDefaultList,
      activeIngredients: this.filtersSummary.activeIngredients,
      marketingBrands: this.filtersSummary.brands,
      yearType: this.filtersSummary.yearTypes
    };
    if (filter.shipToAccounts) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.otiService.getDataOip(filter).subscribe((result: any) => {
        this.SetOipDataSource(result);
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false); }));
    }
  }

  setTableData(data: any) {
    const flattened: any[] = [];
    if (data.packageDateRangeLevel) {
      data.packageDateRangeLevel.forEach(parent => {
        flattened.push({ ...parent, isParent: true });

        if (parent.dateRangeLevel) {
          parent.dateRangeLevel.forEach(child => {
            flattened.push({ ...child, isParent: false });
          });
        }
      });
    }
    this.packageDateRangeDataSource.data = flattened; // <-- bind this to mat-table
  }

  getSelectedIds(listKey: string): string[] {
    const list = this.filtersSummaryMasterData[listKey];
    if (!Array.isArray(list)) return [];

    return list
      .filter(item => item.selected && item.id !== 'ALL')
      .map(item => String(item.id));
  }

  assignYearsHeaders(data: string | null | undefined) {
    if (!data) {
      this.selectedCurrentYear = '';
      this.selectedPreviousYear = '';
      this.selectedPreviousYear2 = '';
      return;
    }

    const parts = data.split(',');

    this.selectedCurrentYear = parts[0] || '';
    this.selectedPreviousYear = parts[1] || '';
    this.selectedPreviousYear2 = parts[2] || '';
  }


  updateDropdownList(
    listKey: string,
    rawData: any[],
    idField: string,
    valueField: string,
    isReset: boolean = false
  ): void {
    let dropdownItems: { id: string; value: string; selected: boolean }[] = [];
    const seen = new Map<string, string>();
    rawData.forEach(x => {
      const id = String(x[idField]);
      const value = x[valueField];
      if (id && value && !seen.has(id)) {
        seen.set(id, value);
      }
    });

    dropdownItems = Array.from(seen.entries()).map(([id, value]) => ({
      id,
      value,
      selected: true,
      data: null
    }));

    dropdownItems.sort((a, b) => {
      if (a.value === "BLANK" && b.value === "BLANK") return 0;
      if (a.value === "BLANK") return -1;
      if (b.value === "BLANK") return 1;
      return a.value.localeCompare(b.value);
    });


    dropdownItems = dropdownItems.map(item => ({
      ...item,
      selected: isReset ? true : item.selected
    }));

    let finalList = [];

    if (dropdownItems.length > 0) {
      const allSelected = dropdownItems.every(item => item.selected);

      finalList = [
        {
          id: 'ALL',
          value: 'ALL',
          selected: isReset ? true : allSelected
        },
        ...dropdownItems
      ];
    }

    this.filtersSummaryMasterData[listKey] = finalList;
  }





  applyFilter(trigger: 'parent' | 'shipto' | 'brand'): void {
    const selectedParents = this.getSelectedIds('parentAccountsList');
    const selectedShipTos = this.getSelectedIds('locationsList');
    const selectedBrands = this.getSelectedIds('brandsList');
    // Step 1: Start from full data
    let filtered = [...this.fullRawListData];

    // Step 2: Filter based on trigger
    if (trigger === 'parent') {
      if (selectedParents.length > 0) {
        filtered = filtered.filter(x => selectedParents.includes(String(x.soldToAccountNumber)));
      }
    }

    if (trigger === 'shipto') {
      if (selectedParents.length > 0) {
        filtered = filtered.filter(x => selectedParents.includes(String(x.soldToAccountNumber)));
      }
      if (selectedShipTos.length > 0) {
        filtered = filtered.filter(x => selectedShipTos.includes(String(x.accountNumber)));
      }
    }

    if (trigger === 'brand') {
      if (selectedParents.length > 0) {
        filtered = filtered.filter(x => selectedParents.includes(String(x.soldToAccountNumber)));
      }
      if (selectedShipTos.length > 0) {
        filtered = filtered.filter(x => selectedShipTos.includes(String(x.accountNumber)));
      }
      if (selectedBrands.length > 0) {
        filtered = filtered.filter(x => selectedBrands.includes(String(x.marketingBrandId)));
      }
    }

    // Step 3: Update dropdowns based on trigger
    switch (trigger) {
      case 'parent':
        this.updateDropdownList('locationsList', filtered, 'accountNumber', 'accountName', false);
        this.updateDropdownList('brandsList', filtered, 'marketingBrandId', 'marketingBrand', false);
        this.updateDropdownList('activeIngredientsList', filtered, 'activeIngredients', 'activeIngredients', false);
        break;

      case 'shipto':
        this.updateDropdownList('brandsList', filtered, 'marketingBrandId', 'marketingBrand', false);
        this.updateDropdownList('activeIngredientsList', filtered, 'activeIngredients', 'activeIngredients', false);
        break;

      case 'brand':
        this.updateDropdownList('activeIngredientsList', filtered, 'activeIngredients', 'activeIngredients', false);
        break;
    }
  }


  toggleItemSelection(listKey: string, itemId: any): void {
    const list = this.filtersSummaryMasterData[listKey];
    if (!list) return;

    if (itemId === 'ALL') {
      const allOthersSelected = list.slice(1).every(item => item.selected);

      list.forEach(item => item.selected = !allOthersSelected);
    } else {
      const item = list.find(x => x.id === itemId);
      if (item) item.selected = !item.selected;

      const allOthersSelected = list.slice(1).every(item => item.selected);
      list[0].selected = allOthersSelected;
    }

    // Save updated list
    this.filtersSummaryMasterData[listKey] = [...list];

    // Trigger dependent updates
    if (listKey === 'parentAccountsList') {
      this.applyFilter('parent');
    } else if (listKey === 'locationsList') {
      this.applyFilter('shipto');
    } else if (listKey === 'brandsList') {
      this.applyFilter('brand');
    }
  }


  getSelectedLabel(key: string, label: string): string {
    const selected = this.filtersSummaryMasterData[key]
      .filter(x => x.id !== 'ALL' && x.selected).length;
    return `${label} (${selected} selected)`;
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTab = tabChangeEvent.index == 0 ? "CPP" : "SEED";
    this.filter.paginatorSize = this.otiOrdersPaginator.pageSize;
    if (
      this.selectedTabIndex === 0 &&
      this.selectedTabIndex !== tabChangeEvent.index
    ) {
      this.cppFilters = JSON.parse(JSON.stringify(this.filter));
      this.filter = JSON.parse(JSON.stringify(this.seedFilters));
      this.otiOrdersPaginator.pageSize = this.filter.paginatorSize;
    } else if (
      this.selectedTabIndex === 1 &&
      this.selectedTabIndex !== tabChangeEvent.index
    ) {
      this.seedFilters = JSON.parse(JSON.stringify(this.filter));
      this.filter = JSON.parse(JSON.stringify(this.cppFilters));
      this.otiOrdersPaginator.pageSize = this.filter.paginatorSize;
    }
    //this.dateRangeInput._startInput.value =
    //  this.filter.fromOrderDate !== null
    //    ? new Date(this.filter.fromOrderDate)
    //    : null;
    //this.dateRangeInput._endInput.value =
    //  this.filter.toOrderDate !== null
    //    ? new Date(this.filter.toOrderDate)
    //    : null;
    this.selectedTabIndex = tabChangeEvent.index;
    this.setHeight();
    this.setSeedOrdersTableHeight();
    if ((this.selectedTab === 'CPP' && this.isCPPAdvancedSearch) || (this.selectedTab === 'SEED' && this.isSEEDAdvancedSearch)) {
      this.showHideDateFilter = false;
      this.getOtiOrdersAdv(this.selectedTab);
    }
    else {
      this.showHideDateFilter = true;
      this.getOtiOrders();
    }
  };

  setHeight() {
    if (window.innerWidth >= 1299) {
      const templateHeight =
        window.innerHeight -
        $(".mat-mdc-tab-header").outerHeight() -
        $(".order-top-sec").outerHeight() -
        100;
      $(".dealertableContainer").css("max-height", templateHeight + "px");
    }
      const templateHeight =
      window.innerHeight -
      $(".mat-mdc-tab-header").outerHeight() -
      $(".order-top-sec").outerHeight() -
      160;
    $(".dealertableContainer").css("max-height", templateHeight + "px");

    const insightsHeight =
      window.innerHeight -
      $(".filtersRow").outerHeight() -
      $(".mat-mdc-tab-header").outerHeight() -
      $(".tab-head").outerHeight() -
      100;
    $(".orderInsightsTable").css("max-height", insightsHeight + "px");
  }

  setSeedOrdersTableHeight() {
    const templateHeight =
      window.innerHeight -
      $(".mat-mdc-tab-header").outerHeight() -
      $(".order-top-sec").outerHeight() -
      100;
    $(".seedOrdersTable").css("max-height", templateHeight + "px");
  }

  setDefaultDateFilter() {
    this.loaderService.setLoaderStatus(true);
    this.defaultPageFilter();
    this.getFilterData();
    this.getOtiOrders(false, true);
  }

  getFilterData() {
    //hardcoded status list
    this.orderStatusList = [
      {
        id: "Cancelled",
        value: "Cancelled",
        data: null,
      },
      {
        id: "Delivered",
        value: "Delivered",
        data: null,
      },
      {
        id: "Invoiced",
        value: "Invoiced",
        data: null,
      },
      {
        id: "Order Created",
        value: "Order Created",
        data: null,
      },
      {
        id: "Order In Progress",
        value: "Order In Progress",
        data: null,
      },
      {
        id: "Shipped In Transit",
        value: "Shipped In Transit",
        data: null,
      }
    ];
  }

  // set Default Page Filter
  defaultPageFilter() {
    const redirectFilter = this.otiService.getFilters();
    this.otiService.clearFilters();

    // Default filter settings
    this.baseFilters = {
      account: null,
      dateInDays: 90,
      fromOrderDate: null,
      toOrderDate: null,
      salesOrderNumber: null,
      customerPO: null,
      orderStatus: null,
      productLineSegment:
        (this.isCPPOrderAccess && this.isSeedOrderAccess) ||
          this.isCPPOrderAccess
          ? "CPP"
          : "SEED",
      searchText: "",
      dateRangeText: "Last 90 days",
      orderStatusText: "ALL",
      paginatorSize: 20,
    };

    // If redirectFilter exists, override default values
    if (redirectFilter) {
      this.currentTab = redirectFilter.productLineSegment === "CPP" ? 0 : 1;
      this.selectedTabIndex = this.currentTab;
      this.filter = {
        ...this.baseFilters,
        salesOrderNumber: redirectFilter.salesOrderNumber,
        customerPO: redirectFilter.customerPO,
        account: redirectFilter.account,
        dateInDays: redirectFilter.dateInDays,
        fromOrderDate: redirectFilter.fromOrderDate,
        toOrderDate: redirectFilter.toOrderDate,
        orderStatus: redirectFilter.orderStatus,
        productLineSegment: redirectFilter.productLineSegment,
        dateRangeText: redirectFilter.dateRangeText,
        orderStatusText: redirectFilter.orderStatusText,
      };
      if (this.currentTab === 0) {
        this.cppFilters = Object.assign({}, this.filter);
        this.seedFilters = Object.assign({}, this.baseFilters);
      } else {
        this.cppFilters = Object.assign({}, this.baseFilters);
        this.seedFilters = Object.assign({}, this.filter);
      }
    } else {
      this.filter = { ...this.baseFilters };
      this.cppFilters = Object.assign({}, this.filter);
      this.seedFilters = Object.assign({}, this.filter);
    }
    this.initialStartDate = this.filter.fromOrderDate
      ? new Date(this.filter.fromOrderDate)
      : null;
    this.initialEndDate = this.filter.toOrderDate
      ? new Date(this.filter.toOrderDate)
      : null;
    this.seedFilters.productLineSegment = "SEED";
    this.cppFilters.productLineSegment = "CPP";
  }

  // get list of orders based on filter
  getOtiOrders(isSearchButtonClick = false, isFirstLoad = false) {
    if (isSearchButtonClick) {
      this.searchInGrid();
    } else {
      this.loaderService.setLoaderStatus(true);
      const payload = {
        account: this.filter.account,
        dateInDays: this.filter.dateInDays,
        fromOrderDate: this.filter.fromOrderDate,
        toOrderDate: this.filter.toOrderDate,
        salesOrderNumber: this.filter.salesOrderNumber,
        customerPO: this.filter.customerPO,
        orderStatus: this.filter.orderStatus,
        productLineSegment: this.filter.productLineSegment,
      };
      if (this.filter.productLineSegment === "CPP") {
        this.loadApi(this.otiService.getOTIOrderLandingList(payload), isFirstLoad);
      } else {
        this.loadApi(this.otiService.getOTISeedOrderLandingList(payload), isFirstLoad);
      }
    }
  }

  clearOSSFilter() {
    this.filter.searchText = '';
    if (this.selectedTab == "CPP") {
      this.currentSearchCriteriaCpp = [];
      if (this.isCPPAdvancedSearch) {
        this.resetFilters(this.selectedTab);
        this.getOtiOrders();
      }
      else {
        this.isCPPAdvancedSearch = false;
        this.searchInGrid();
      }
    }
    else {
      this.currentSearchCriteriaSeed = [];
      if (this.isSEEDAdvancedSearch) {
        this.resetFilters(this.selectedTab);
        this.getOtiOrders();
      }
      else {
        this.isSEEDAdvancedSearch = false;
        this.searchInGrid();
      }
    }
    this.showHideDateFilter = true;
  }

  resetFilters(selectedTab) {
    this.filter.dateInDays = 90;
    this.filter.fromOrderDate = null;
    this.filter.toOrderDate = null;
    this.filter.dateRangeText = "Last 90 days";
    this.filter.orderStatusText = "ALL";
    this.filter.orderStatus = '';
    if (selectedTab === 'CPP') {
      this.currentSearchCriteriaCpp = null;
      this.isCPPAdvancedSearch = false;
    }
    else {
      this.currentSearchCriteriaSeed = null;
      this.isSEEDAdvancedSearch = false;
    }
  }

  loadApi(serviceCall: Observable<any[]>, isFirstLoad = false) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(
      serviceCall.subscribe(
        (result: any) => {
          let orders = result;
          if (result && result.resultData) {
            orders = result.resultData;
            if (result.message) {
              this.shippedInTransitMessage = result.message;
            }
          }
          this.otiOrdersList = orders;
          this.otiOrdersDataSource = new MatTableDataSource(orders);
          this.otiOrdersDataSource.paginator = this.otiOrdersPaginator;
          this.otiOrdersDataSource.paginator.firstPage();
          this.otiOrdersDataSource.sort = this.otiOrdersSort;
          this.loaderService.setLoaderStatus(false);
          this.searchInGrid();
          this.setHeight();
          this.setSeedOrdersTableHeight();
          //if (isFirstLoad) {
          //  this.checkSurveyMessageEligibilty();
          //}
        },
        (error) => {
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }

  // Get OTI orders report
  getExcelReport() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);

    let result;
    if (!this.filter.searchText) {
      result = this.otiOrdersList;
    } else {
      if (this.otiOrdersDataSource.data && this.otiOrdersDataSource.data.length > 0) {
        result = this.otiOrdersDataSource.data;
      }
    }

    if (result && result.length > 0) {
      result.forEach((child) => {
        // Iterate over each element in the child list using forEach
        child.childOrder.forEach((x) => {
          if (this.filter.productLineSegment === "CPP") {
            exportData.push({
              "Web Order Number": x.webOrderNumber,
              "Order Number": x.orderNumber,
              "Customer PO": x.customerPO,
              "Order Date": this.datePipe.transform(x.orderDate, "MM/dd/yyyy"),
              "Requested Delivery Date": this.datePipe.transform(
                x.requestedDeliveryDate,
                "MM/dd/yyyy"
              ),
              "Order Type": x.orderTypeText,
              Product: x.productName,
              Vendor: x.vendor,
              "Account#": x.accountNumber,
              "Account Name": x.accountName,
              "Account Address": x.accountAddress1 || x.accountAddress2,
              "Account City": x.accountCity,
              "Account State": x.accountState,
              "Ordered Qty": x.orderedQty,
              "Delivered Qty": x.deliveredQty,
              UOM: x.uom,
              "Unit Price": x.unitPrice,
              "Pricing UOM": x.pricingUOM,
              "Total Line Amt": "$ " + x.lineAmount,
              Status: x.orderStatus,
              Tracking: x.trackingURL,
            });
          } else {
            exportData.push({
              "Order Number": x.orderNumber,
              "Customer PO#": x.customerPO,
              "Order Date": this.datePipe.transform(x.orderDate, "MM/dd/yyyy"),
              "Order Type": x.orderTypeText,
              "Item Description": x.productName,
              "Marketing Brand": x.vendor,
              "Account#": x.accountNumber,
              "Account Name": x.accountName,
              "Account Address": x.accountAddress1 || x.accountAddress2,
              "Account City": x.accountCity,
              "Account State": x.accountState,
              "Lot Number": x.lotNumber,
              "Ordered Qty": x.orderedQty,
              "Delivered Qty": x.deliveredQty,
              Status: x.orderStatus,
              Tracking: x.trackingURL,
            });
          }
        });
      });

      this.excelService.exportAsExcelFile(exportData, "My Orders");
    } else {
      this.toastrService.error(
        "No order available for current user and filters"
      );
    }
    this.loaderService.setLoaderStatus(false);
  }

  //client side search on top textbox
  searchInGrid() {
    this.loaderService.setLoaderStatus(true);
    if (this.filter.productLineSegment === "CPP" && this.isCPPAdvancedSearch == true) {
      this.loaderService.setLoaderStatus(false);
      return;
    }
    if (this.filter.productLineSegment === "SEED" && this.isSEEDAdvancedSearch == true) {
      this.loaderService.setLoaderStatus(false);
      return;
    }
    if (!this.filter.searchText) {
      this.otiOrdersDataSource.data = this.otiOrdersList;
    }
    else if (this.otiOrdersList && this.otiOrdersList.length > 0 && this.filter.searchText.trim().length >= 3) {
      //// create Fuse instance on your data (otiOrdersList)
      //const fuse = new Fuse(this.otiOrdersList, {
      //  keys: ['searchText', 'productName', 'vendor'],   // field to search in
      //  threshold: 0.4,         // 0.0 = exact match, 1.0 = very fuzzy
      //  ignoreLocation: true    // don't penalize word position
      //});

      if (this.filter.searchText.includes('+')) {

        // multiple keyword -  & 379691
        var productNameList = this.filter.productLineSegment === "CPP" ? this.productSearchListDataCPP : this.productSearchListDataSEED;

        var searchText = this.filter.searchText.toLowerCase();
        let searchKeywords = searchText
          .split('+')
          .map(p => p.trim())
          .filter(p => p.length > 0);

        let pnVNSearchList: { searchKey: string; matchedWord: string }[] = [];
        let pnVNKeywords: string[] = [];       

        // Find each keyword in ProductNameSearchList - Fuzzy Search
        searchKeywords.forEach(keyword => {
          const result = this.filterOptions(keyword, productNameList);
          if (result && result.length > 0) {
            result.forEach(r => {
              pnVNSearchList.push({ searchKey: keyword, matchedWord: r });
            });
          }          
        });

        // Find each keyword in VendorNameSearchList - Fuzzy Search
        searchKeywords.forEach(keyword => {
          const result = this.filterOptions(keyword, this.vendorSearchListData);
          if (result && result.length > 0) {
            result.forEach(r => {
              pnVNSearchList.push({ searchKey: keyword, matchedWord: r });
            });
          }
        });

        // Remove duplicates (distinct by both searchKey + matchedWord)
        pnVNSearchList = pnVNSearchList.filter(
          (value, index, self) =>
            index === self.findIndex(
              (t) => t.searchKey === value.searchKey && t.matchedWord === value.matchedWord
            )
        );

        if (pnVNSearchList && pnVNSearchList.length > 0) {
          //console.log('Found PNVN list');

          // There are one or more values fetched in PNVN list
          // Then use the Product Name and Vendor Name and select matching lines from all the lines are available
          //var productVendorSearchList = this.otiOrdersList.filter((item) =>
          //  pnVNSearchList.some((word) =>
          //    item.productName.toLowerCase().includes(word.toLowerCase()) ||
          //    item.vendor.toLowerCase().includes(word.toLowerCase())
          //  )
          //);

          var productVendorSearchList = this.otiOrdersList.filter((item) => {
            const itemMatches = pnVNSearchList.filter((keyword) =>
              item.productName.toLowerCase().includes(keyword.matchedWord.toLowerCase()) ||
              item.vendor.toLowerCase().includes(keyword.matchedWord.toLowerCase())
            );

            // add matched keywords
            pnVNKeywords.push(...itemMatches.map(m => m.searchKey));

            return itemMatches.length > 0; // keep only items with matches
          });

          // remove duplicates from matchedWords
          pnVNKeywords = Array.from(new Set(pnVNKeywords));
          if (productVendorSearchList && productVendorSearchList.length > 0) {
            //console.log('Found search list by PNVN');
            // After applying the PNVN list filter - At least one or more record(s) were found.
            // Then build the SearchText list against the above lines which are fetched above.

            // Create fuzyness on PNVN list for SearchText, ProductName and VendorName

            ////const fusePNVN = new Fuse(productVendorSearchList, {
            ////  keys: ['productName', 'vendor'],   // field to search in
            ////  threshold: 0.4,         // 0.0 = exact match, 1.0 = very fuzzy
            ////  ignoreLocation: true    // don't penalize word position
            ////});

            //var resultBySearchText = productVendorSearchList;
            //searchKeywords.forEach(word => {
            //  const searchResult = fuse.search(word);
            //  // fuse.search returns array of objects { item, refIndex, score }
            //  resultBySearchText = resultBySearchText.filter(item =>
            //    searchResult.some(r => r.item === item)
            //  );
            //});

            //console.log('Performing search by PNVN');
            // for case 2.2 we are for search text for each keywords
            //const resultByPNVN = productVendorSearchList.filter(item =>
            //  pnVNKeywords.every(word =>
            //    fusePNVN.search(word).some(r => r.item === item)
            //  )
            //);


            const resultByPNVN = productVendorSearchList.filter(item =>
              pnVNKeywords.every(word => {
                // collect fields to search in
                const fields = [item.productName, item.vendor];

                // run custom fuzzy function on each field
                return fields.some(field => {
                  const matches = this.filterOptions(word, [field]);
                  return matches && matches.length > 0; // means the word matched this field
                });
              })
            );

            var otherSearchKeywords = searchKeywords.filter(k => !pnVNKeywords.includes(k));
            if (otherSearchKeywords && otherSearchKeywords.length > 0 && resultByPNVN && resultByPNVN.length > 0) {

              let resultByOtherKeywords = resultByPNVN.filter((item) =>
                otherSearchKeywords.every((word) => item.searchText.toLowerCase().includes(word))
              );

              // search by text - again search by text
              let resultBySearchText = this.otiOrdersList.filter((item) =>
                searchKeywords.every((word) =>
                  item.searchText.toLowerCase().includes(word)
                )
              );

              //console.log('searched by other fields');
              let finalSearchList = [...resultByOtherKeywords, ...resultBySearchText];

              let finalCombinedDistinctList = finalSearchList.filter(
                (item, index, self) =>
                  index === self.findIndex((t) =>
                    JSON.stringify(t) === JSON.stringify(item)
                  )
              );

              this.otiOrdersDataSource.data = finalCombinedDistinctList;      
            }
            else {
              // search by text - again search by text
              let resultBySearchText = this.otiOrdersList.filter((item) =>
                                    searchKeywords.every((word) =>
                                      item.searchText.toLowerCase().includes(word)
                                    )
                                    );

              let finalSearchList = [...resultByPNVN, ...resultBySearchText];

              let finalCombinedDistinctList = finalSearchList.filter(
                (item, index, self) =>
                  index === self.findIndex((t) =>
                    JSON.stringify(t) === JSON.stringify(item)
                  )
              );

              this.otiOrdersDataSource.data = finalCombinedDistinctList;            
            }
          }
          else {
            //console.log('Exact Search because Not Found search list by PNVN');
            // After applying the PNVN list filter - No Records were found.
            // build SearchText list - each keyword should match in the line

            //this.otiOrdersDataSource.data = this.otiOrdersList.filter(item =>
            //  searchKeywords.every(word =>
            //    fuse.search(word).some(r => r.item === item)
            //  )
            //);

            // exact match
            this.otiOrdersDataSource.data = this.otiOrdersList.filter((item) =>
              searchKeywords.every((word) =>
                item.searchText.toLowerCase().includes(word)
              )
            );
          }
        }
        else {
          //console.log('Exact Search because Not Found PNVN list');
          // if no data in PNVN list
          // build SearchText list - each keyword should match in the line

          //this.otiOrdersDataSource.data = this.otiOrdersList.filter(item =>
          //  searchKeywords.every(word =>
          //    fuse.search(word).some(r => r.item === item)
          //  )
          //);

          // exact match
          this.otiOrdersDataSource.data = this.otiOrdersList.filter((item) =>
            searchKeywords.every((word) =>
              item.searchText.toLowerCase().includes(word)
            )
          );
        }
      }
      else {
        // single keyword
        var searchKeyword = this.filter.searchText.trim().toLowerCase();

        var productNameList = this.filter.productLineSegment === "CPP" ? this.productSearchListDataCPP : this.productSearchListDataSEED;

        // Find product names based on search keyword - Fuzzy Search
        var matchedProductList = this.filterOptions(searchKeyword, productNameList);

        // Find vendor names based on search keyword - Fuzzy Search
        var matchedVendorList = this.filterOptions(searchKeyword, this.vendorSearchListData);

        var resultByProductSearch = this.otiOrdersList.filter((item) =>
          matchedProductList.some((word) => item.productName.toLowerCase().includes(word.toLowerCase()))
        );

        //console.log(resultByProductSearch);

        var resultByVendorSearch = this.otiOrdersList.filter((item) =>
          matchedVendorList.some((word) => item.vendor.toLowerCase().includes(word.toLowerCase()))
        );

        //let resultBySearchText = this.otiOrdersList;
        //const searchResult = fuse.search(searchKeyword);
        //// fuse.search returns array of objects { item, refIndex, score }
        //resultBySearchText = resultBySearchText.filter(item =>
        //  searchResult.some(r => r.item === item)
        //);

        //searchKeywords.forEach(word => {
        //  const searchResult = fuse.search(word);
        //  // fuse.search returns array of objects { item, refIndex, score }
        //  results = results.filter(item =>
        //    searchResult.some(r => r.item === item)
        //  );
        //});

        let resultBySearchText = this.otiOrdersList.filter((item) =>
          item.searchText.toLowerCase().includes(searchKeyword)
        );

        // Combine serach results
        let finalSearchList = [...resultByProductSearch, ...resultByVendorSearch, ...resultBySearchText];

        let finalCombinedDistinctList = finalSearchList.filter(
          (item, index, self) =>
            index === self.findIndex((t) =>
              JSON.stringify(t) === JSON.stringify(item)
            )
        );

        this.otiOrdersDataSource.data = finalCombinedDistinctList;

        //  const searchWords = this.filter.searchText
        //    .toLowerCase()
        //    .replace(/\s+/g, " ")
        //    .trim()
        //    .split(" ");

        //  this.otiOrdersDataSource.data = this.otiOrdersList.filter((item) =>
        //    searchWords.some((word) => item.searchText.toLowerCase().includes(word))
        //  );
      }
    }

    this.loaderService.setLoaderStatus(false);
  }

  //FuzzySearch
  filterOptions(name: string, itemSearchList: any) {
    var list;
    if (name && name != '' && name.length >= 3) {
      name = name.trim();
      list = itemSearchList.filter(a => a.indexOf(name.trim().toLocaleUpperCase()) == 0);

      if (list.length <= 0) {
        var len = name.length >= 4 ? name.length - 2 : 2;
        const fuse = new Fuse(itemSearchList, { minMatchCharLength: len, threshold: 0.4 });
        list = fuse.search(name).map(a => a.item);
      }
      else {
        list = list.concat(itemSearchList.filter(a => a.indexOf(' ' + name.toLocaleUpperCase()) > 0));
      }
    }
    return list;
  }

  performAdvancedSearch(searchParams: any) {
    var buildSearchKeyowrds = 'AS: ';
    var searchTerms = [];

    if (searchParams.accountNames && searchParams.accountNames.length > 0) {
      searchTerms.push(...searchParams.accountNames);
    }
    if (searchParams.customerPOs && searchParams.customerPOs.length > 0) {
      searchTerms.push(...searchParams.customerPOs);
    }
    if (searchParams.orderNumbers && searchParams.orderNumbers.length > 0) {
      searchTerms.push(...searchParams.orderNumbers);
    }
    if (searchParams.orderTypeNames && searchParams.orderTypeNames.length > 0) {
      searchTerms.push(...searchParams.orderTypeNames);
    }
    if (searchParams.productLabels && searchParams.productLabels.length > 0) {
      searchTerms.push(...searchParams.productLabels);
    }
    if (searchParams.shipmentNumbers && searchParams.shipmentNumbers.length > 0) {
      searchTerms.push(...searchParams.shipmentNumbers);
    }
    if (searchParams.vendorNames && searchParams.vendorNames.length > 0) {
      searchTerms.push(...searchParams.vendorNames);
    }
    if (searchParams.webOrderNumbers && searchParams.webOrderNumbers.length > 0) {
      searchTerms.push(...searchParams.webOrderNumbers);
    }
    if (searchParams.deliveryDateFrom) {
      const deliveryDateFrom = new Date(searchParams.deliveryDateFrom)
        .toLocaleDateString("en-US"); // MM/DD/YYYY
      searchTerms.push(deliveryDateFrom);
    }
    if (searchParams.deliveryDateTo) {
      const deliveryDateTo = new Date(searchParams.deliveryDateTo)
        .toLocaleDateString("en-US"); // MM/DD/YYYY
      searchTerms.push(deliveryDateTo);
    }
    if (searchParams.orderDateFrom) {
      const orderDateFrom = new Date(searchParams.orderDateFrom)
        .toLocaleDateString("en-US"); // MM/DD/YYYY
      searchTerms.push(orderDateFrom);
    }
    if (searchParams.orderDateTo) {
      const orderDateTo = new Date(searchParams.orderDateTo)
        .toLocaleDateString("en-US"); // MM/DD/YYYY
      searchTerms.push(orderDateTo);
    }

    buildSearchKeyowrds += searchTerms.join("+");
    this.filter.searchText = buildSearchKeyowrds;

    if (searchParams.searchType === "CPP") {
      this.isCPPAdvancedSearch = true;
    }
    else {
      this.isSEEDAdvancedSearch = true;
    }
  }

  setDateFilter(id, text, days, event) {
    if (id == 2) {
      this.filter.dateInDays = 0;
      if (event.value) {
        this.filter.fromOrderDate = new Date(event.value).toDateString();
        this.searchOrderFromDate = event.value;
      }
    } else if (id == 3) {
      this.filter.dateInDays = 0;
      if (event.value) {
        this.filter.toOrderDate = new Date(event.value).toDateString();
        this.searchOrderToDate = event.value;
      }
    } else if (id == 4 || days > 0) {
      this.filter.dateInDays = 0;
      this.filter.fromOrderDate = null;
      this.filter.toOrderDate = null;
      this.filter.dateRangeText = "";

      this.dateRangeInput._startInput.value = null;
      this.dateRangeInput._endInput.value = null;
    }
    this.filter.dateInDays = days;
    this.filter.dateRangeText = text;
    if (
      (this.filter.fromOrderDate != null && this.filter.toOrderDate != null) ||
      this.filter.dateInDays > 0
    ) {
      this.filter.dateRangeText =
        this.filter.dateInDays <= 0
          ? this.datePipe.transform(this.filter.fromOrderDate, "MM/dd/yyyy") +
          " - " +
          this.datePipe.transform(this.filter.toOrderDate, "MM/dd/yyyy")
          : this.filter.dateRangeText;
      this.menu.closeMenu();
      this.getOtiOrders();
    }
  }

  openPopup(data: any) {
    this.otiOrderDetailSliderModelService.orderNumber.next(data.orderNumber);
    this.otiOrderDetailSliderModelService.orderType.next(data.orderType);
    this.otiOrderDetailSliderModelService.activeSlider("otiOrderDetailSlider");
  }

  setStatusFilter(val) {
    if (this.filter.searchText && (this.isSEEDAdvancedSearch || this.isCPPAdvancedSearch)) {

      this.filter.orderStatusText = val;
      if (val == "") {
        this.filter.orderStatusText = "ALL";
      }
      this.filter.orderStatus = val;
      if (this.selectedTab === "CPP") {
        this.performAdvancedSearch(this.currentSearchCriteriaCpp);
        this.getOtiOrdersAdv(this.selectedTab);
      }
      else {
        this.performAdvancedSearch(this.currentSearchCriteriaSeed);
        this.getOtiOrdersAdv(this.selectedTab);
      }
    }
    else {
      this.filter.orderStatusText = val;
      if (val == "") {
        this.filter.orderStatusText = "ALL";
      }
      this.filter.orderStatus = val;
      this.getOtiOrders();

    }
  }

  // Show details
  showDetails(element): void {
    if (element.childOrder.length > 1) {
      element.selected = !element.selected;
    }
  }

  //add status class
  addStatusClass(status) {
    if (status == "Cancelled") {
      return "redBg";
    } else if (status == "Delivered") {
      return "blueBg";
    } else {
      return "yellowBg";
    }
  }

  onPickerClosed() {
    this.isPickerOpen = false;
  }
  openAdvancedSearch(): void {
    if (this.selectedTab == 'CPP' && !this.isCPPAdvancedSearch) {
      if (this.filter.dateInDays > 0) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const pastDate = new Date();
        pastDate.setDate(today.getDate() - this.filter.dateInDays);
        pastDate.setHours(0, 0, 0, 0);
        let searchDateData = {
          orderDateFrom: pastDate,
          orderDateTo: today
        }

        this.currentSearchCriteriaCpp = searchDateData;
      }
      else {
        let searchDateData = {
          orderDateFrom: this.searchOrderFromDate ? this.searchOrderFromDate : this.searchOrderToDate,
          orderDateTo: this.searchOrderToDate ? this.searchOrderToDate : this.searchOrderFromDate
        }

        this.currentSearchCriteriaCpp = searchDateData;
      }
    }
    else if (this.selectedTab == 'SEED' && !this.isSEEDAdvancedSearch) {
      if (this.filter.dateInDays > 0) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const pastDate = new Date();
        pastDate.setDate(today.getDate() - this.filter.dateInDays);
        pastDate.setHours(0, 0, 0, 0);
        let searchDateData = {
          orderDateFrom: pastDate,
          orderDateTo: today
        }
        this.currentSearchCriteriaSeed = searchDateData;
      }
      else {
        let searchDateData = {
          orderDateFrom: this.searchOrderFromDate ? this.searchOrderFromDate : this.searchOrderToDate,
          orderDateTo: this.searchOrderToDate ? this.searchOrderToDate : this.searchOrderFromDate
        }
        this.currentSearchCriteriaSeed = searchDateData;
      }
    }

    const dialogRef = this.dialog.open(OtiAdvancedSearchComponent, {
      width: '900px',
      maxWidth: '90vw',
      disableClose: true,
      panelClass: 'advanced-search-dialog', data: {
        searchType: this.selectedTab,
        searchCriteria: this.selectedTab == "CPP" ? this.currentSearchCriteriaCpp : this.currentSearchCriteriaSeed
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.action === 'search') {
        console.log(result.searchCriteria);
        this.performAdvancedSearch(result.searchCriteria);
        const payload = this.createAdvancedSearchPayload(result.searchCriteria);

        if (payload.productLineSegment === "CPP") {
          this.loadApi(this.otiService.getOTIOrderLandingList(payload));
          this.currentSearchCriteriaCpp = result.searchCriteria;
        }
        else {
          this.loadApi(this.otiService.getOTISeedOrderLandingList(payload));
          this.currentSearchCriteriaSeed = result.searchCriteria;
        }
        this.showHideDateFilter = false;
      }
    });
  }

  getOtiOrdersAdv(selectedTab) {
    if (selectedTab === 'CPP') {
      const payload = this.createAdvancedSearchPayload(this.currentSearchCriteriaCpp);
      this.loadApi(this.otiService.getOTIOrderLandingList(payload));  
    }
    else {
      const payload = this.createAdvancedSearchPayload(this.currentSearchCriteriaSeed);
      this.loadApi(this.otiService.getOTISeedOrderLandingList(payload));
    }
  }

  validateAdvancedSearch(searchInput: HTMLInputElement) {
    if (this.filter.productLineSegment === "CPP" && this.isCPPAdvancedSearch == true) {
      searchInput.blur();
      this.openAdvancedSearch();
    }
    else if (this.filter.productLineSegment === "SEED" && this.isSEEDAdvancedSearch == true) {
      searchInput.blur();
      this.openAdvancedSearch();
    }
  }
  private createAdvancedSearchPayload(searchCriteria: any): any {
    return {
      // Date filters
      fromOrderDate: searchCriteria.orderDateFrom ? new Date(searchCriteria.orderDateFrom).toDateString() : null,
      toOrderDate: searchCriteria.orderDateTo ? new Date(searchCriteria.orderDateTo).toDateString() : null,
      fromDeliveryDate: searchCriteria.deliveryDateFrom ? new Date(searchCriteria.deliveryDateFrom).toDateString() : null,
      toDeliveryDate: searchCriteria.deliveryDateTo ? new Date(searchCriteria.deliveryDateTo).toDateString() : null,

      // CSV fields - join arrays back to comma-separated strings
      webOrderNumbers: searchCriteria.webOrderNumbers?.length > 0
        ? searchCriteria.webOrderNumbers.join(',') : null,
      orderNumbers: searchCriteria.orderNumbers?.length > 0
        ? searchCriteria.orderNumbers.join(',') : null,
      customerPOs: searchCriteria.customerPOs?.length > 0
        ? searchCriteria.customerPOs.join(',') : null,
      shipmentNumbers: searchCriteria.shipmentNumbers?.length > 0
        ? searchCriteria.shipmentNumbers.join(',') : null,

      // Multi-select dropdowns - join arrays back to comma-separated strings
      accounts: searchCriteria.accounts?.length > 0
        ? searchCriteria.accounts.join(',') : null,
      orderTypes: searchCriteria.orderTypeNames?.length > 0
        ? searchCriteria.orderTypeNames.join(',') : null,
      vendors: searchCriteria.vendors?.length > 0
        ? searchCriteria.vendors.join(',') : null,
      productNames: searchCriteria.productNames?.length > 0
        ? searchCriteria.productNames.join(',') : null,

      // Search type
      productLineSegment: searchCriteria.searchType || this.selectedTab,
      isAdvancedSearch: true,
      orderStatus: this.filter.orderStatus
    };
  }

  showSurveyMessage() {
    const title = 'Evolve Survey';
    const message = 'Would you like to take a 2-3 minutes survey with 5 questions?';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '450px',
      data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', labelLater: 'Later', dialogType: 'surveyForm' }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe((res: string) => {
      this.saveSurveyPreference(res);
    }));
  }

  saveSurveyPreference(userSurveyPref) {
    if (userSurveyPref === 'YES') {
      window.open(this.evolveSurveyUrl, '_blank', 'noopener,noreferrer');
    }
    this.loaderService.setLoaderStatus(true);
    var response = JSON.stringify(userSurveyPref);
    this.subscription.push(this.otiService.saveSurveyPreference(response).subscribe((result: any) => {
      this.loaderService.setLoaderStatus(false);

    }, error => this.loaderService.setLoaderStatus(false)));
  }

  ngOnDestroy() {
    if (this.surveyTimeoutId) {
      clearTimeout(this.surveyTimeoutId);
    }
    this.subscription.forEach((sub) => sub.unsubscribe());
    this.otiService.clearFilters();
  }
}
interface DropdownItem {
  id: number | string;
  value: string;
  selected: boolean;
  data: string;
}
